export enum ApplicationType {
  ADMIN_APP,
  ENTERPRISE_APP,
}

const getClientBaseUrl = (applicationType: ApplicationType) => {
  const environment = process.env.NEXT_PUBLIC_CLIENT_ENV;

  switch (applicationType) {
    case ApplicationType.ADMIN_APP:
      if (environment === 'development') {
        return 'http://localhost:3001';
      }

      // @ts-ignore
      if (environment === 'staging') {
        return 'https://admin.staging.commenda.io';
      }

      // @ts-ignore
      if (environment === 'demo') {
        return 'https://admin.demo.commenda.io';
      }

      return 'https://admin.commenda.io/';

    case ApplicationType.ENTERPRISE_APP:
      if (environment === 'development') {
        return 'http://localhost:3003';
      }

      // @ts-ignore
      if (environment === 'staging') {
        return 'https://app.staging.commenda.io';
      }

      // @ts-ignore
      if (environment === 'demo') {
        return 'https://app.demo.commenda.io';
      }

      return 'https://app.commenda.io';

    default:
      return null;
  }
};

export default getClientBaseUrl;
